/* global I18n */

import OrderItemsStore from './order_items_store'
import Track from 'tracking_events/scripts/track'
import WebsiteConfigs from 'website_configs/website_configs'
import Currency from 'utils/currency'
import UtmTracker from 'utils/utm_tracker'
import LeadMedium from 'utils/lead_medium'

const currency = Currency.getCurrency()

const shippingFields = {
  shipping_address_line_1: 'address_line_1',
  shipping_address_line_2: 'address_line_2',
  shipping_city: 'city',
  shipping_postal_code: 'postal_code',
  shipping_region: 'region_state',
  shipping_country: 'country'
}

class CheckoutForm {
  constructor ($parent, params = {}) {
    this.$parent = $parent

    this.showBack = false
    this.onBack = () => {
    }
    this.onNext = () => {
    }

    if (params['withOffer']) {
      this.withOffer = true
      this.totalPrice = params['totalPrice']
    }
  }

  get requiredCustomFieldIds () {
    return $.map($('[data-required=true]'), val => val.id)
  }

  get customRules () {
    return this.requiredCustomFieldIds.reduce((object, id) => {
      object[id.replace('_', ' ')] = { required: true }
      return object
    }, {})
  }

  loadAndRenderLeadForm () {
    $.getJSON('/api/leads/new', { id: 'webshop_lead_form' }, (json) => {
      this.leadTemplate = json.html
      this.renderTemplate()
    })
  }

  render () {
    if (WebsiteConfigs.createWebshopLead) {
      this.loadAndRenderLeadForm()
    } else {
      this.renderTemplate()
    }
  }

  renderTemplate () {
    this.$parent.html(this.template).ready(() => {
      this.$form = this.$parent.find('form')
      this.$element = this.$parent.children().first()
      this.privacyCheckbox = this.$form.find("[name='privacy_policy']")
      this.bindEvents()
      this.fetchCountriesList().then(() => {
        this.prefillForm()
      })
      this.bindPrivacyCheckbox()
      if (!WebsiteConfigs.createWebshopLead) {
        this.bindShippingMethodButton()
      }
    })
  }

  bindEvents () {
    this.$parent.find('.checkout-form--back').on('click', (e) => {
      e.preventDefault()

      this.onBack()
    })

    this.$form.validate({
      submitHandler: () => { this.onSubmit() },
      rules: {
        offer: {
          required: true
        },
        first_name: {
          required: true
        },
        last_name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        address_line_1: {
          required: true
        },
        address_line_2: {
          required: false
        },
        city: {
          required: true
        },
        region_state: {
          required: true
        },
        postal_code: {
          required: true
        },
        country: {
          required: true
        },
        phone: {
          required: true
        },
        message: {
          required: !WebsiteConfigs.createWebshopLead
        },
        terms_of_sales_checkbox: {
          required: true
        },
        ...this.customRules
      },
      messages: {
        offer: {
          required: I18n.t('validation.offer')
        },
        first_name: {
          required: I18n.t('validation.first_name')
        },
        last_name: {
          required: I18n.t('validation.last_name')
        },
        email: {
          required: I18n.t('validation.email'),
          email: I18n.t('validation.email')
        },
        phone: {
          required: I18n.t('validation.phone')
        },
        address_line_1: {
          required: I18n.t('validation.address_line_1')
        },
        address_line_2: {
          required: I18n.t('validation.address_line_2')
        },
        city: {
          required: I18n.t('validation.city')
        },
        region_state: {
          required: I18n.t('validation.region_state')
        },
        postal_code: {
          required: I18n.t('validation.postal_code')
        },
        country: {
          required: I18n.t('validation.country')
        },
        message: {
          required: I18n.t('validation.message')
        },
        terms_of_sales_checkbox: {
          required: I18n.t('validation.terms_of_sales_checkbox')
        }
      }
    })
  }

  fetchCountriesList () {
    return $.get('/api/countries')
      .then((response) => {
        this.populateCountriesList(response)
      }).catch((error) => {
        console.error(error)
        this.showErrorMessage(I18n.t('could_not_load_countries'))
      })
  }

  populateCountriesList = (countries) => {
    const $countrySelect = this.$element.find('#country')

    countries.forEach((country) => {
      $countrySelect.append(`<option value="${country.iso_code}">${country.name}</option>`)
    })
  }

  onSubmit () {
    event.preventDefault()

    this.disabledSubmitButton()

    this.createOrder().then((result) => {
      this.onSuccess()
    }).catch((error) => {
      this.onError(error)
    }).finally(() => {
      this.enableSubmitButton()
    })
  }

  createOrder () {
    return new Promise((resolve, reject) => {
      if (this.submittedOrder) {
        return resolve(this.submittedOrder)
      } else {
        $.ajax({
          url: '/api/orders',
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            order: {
              ...this.formData,
              utm_params: UtmTracker.getUtmParams()
            },
            lead_medium: { name: LeadMedium.getName() }
          })
        }).done((result) => {
          this.submittedOrder = result

          return resolve(this.submittedOrder)
        }).fail((error) => {
          return reject(error)
        })
      }
    })
  }

  onSuccess () {
    this.isSuccess = true

    localStorage.setItem('contacts', JSON.stringify({
      ...this.formData,
      message: null,
      offer: null
    }))

    this.trackOrder()
    OrderItemsStore.clear()

    if (WebsiteConfigs.enableThankYouPage) {
      const url = new URL(window.location.href)
      url.pathname = '/thank-you'
      const message = new DOMParser().parseFromString(this.successTemplate, 'text/html').documentElement.textContent.trim().replace(/\s\s+/g, '\n')
      url.searchParams.set('message', message)
      window.location.href = url.toString()
    } else {
      this.render()
    }
  }

  onError (error) {
    if (error.status === 422) {
      const errors = JSON.parse(error.responseText)['errors'].map((error) => {
        return error.detail
      }).join('<br>')

      this.showErrorMessage(errors)
    }
  }

  showErrorMessage = (message) => {
    this.$form.find('#error_alert').show()
    this.$form.find('.error-message').html(message)
  }

  prefillForm () {
    const contacts = JSON.parse(localStorage.getItem('contacts') || '{}')

    if (contacts) {
      this.$form.find('select[name="country"], textarea:not([name="message"]), input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([autocomplete="off"])').each((index, input) => {
        const value = contacts[input.name]
        if (value) {
          input.value = value
        }
      })
    }
  }

  disabledSubmitButton () {
    this.$form.find('[type="submit"]').attr('disabled', true)
  }

  enableSubmitButton () {
    this.$form.find('[type="submit"]').removeAttr('disabled')
  }

  bindPrivacyCheckbox () {
    this.privacyCheckbox.on('change', (e) => e.target.checked ? this.enableSubmitButton() : this.disabledSubmitButton())
  }

  bindShippingMethodButton () {
    const shippingAddressField = this.$form.find('.shipping-address')
    this.$form.find('input[name="shipping_method"]').on('change', (e) => {
      if (e.target.checked && e.target.value === 'pick_up_at_location') {
        shippingAddressField.find('input, select, textarea').val('')
        shippingAddressField.hide('slow')
      } else {
        shippingAddressField.show('slow')
      }
    })
  }

  trackOrder () {
    new Track().send('event', {
      event_category: 'order_submit'
    })

    if (window.gtagEnhancedConversionSetup && this.formData && this.formData.email) {
      window.gtagEnhancedConversionSetup(this.formData.email)
    }

    if (window.gtagReportConversion) {
      window.gtagReportConversion()
    }

    if (window.onOrderSubmitted && typeof window.onOrderSubmitted === 'function') {
      window.onOrderSubmitted({
        listing_ids: this.formData.items_attributes.map(el => el.listing_id),
        items: this.formData.items_attributes,
        value: this.totalPrice,
        currency: this.formData.currency
      })
    }
  }

  get formData () {
    const order = this.$form.serializeArray().reduce((acc, item) => {
      acc[item.name] = item.value
      return acc
    }, {})

    Object.assign(order, this.shippingAttributes(order))
    order.items_attributes = OrderItemsStore.getValidItems()
    order.currency = currency

    return order
  }

  shippingAttributes (order) {
    const name = [order.first_name, order.last_name].filter(Boolean).join(' ')
    const attributes = { shipping_name: name || null }

    Object.entries(shippingFields).forEach(([attribute, field]) => {
      attributes[attribute] = order[field] || null
    })

    return attributes
  }

  get successTemplate () {
    return `
      <div class="text-center">
        ${this.withOffer ? `<h5>${I18n.t('thank_you_for_your_offer')}</h5>` : `
        <h5>${I18n.t(WebsiteConfigs.createWebshopLead ? 'thank_you_for_your_inquiry_short' : 'thank_you_for_your_order')}</h5>
        <h5>${I18n.t('we_will_contact_shortly')}</h5>`}
      </div>
      `
  }

  get template () {
    if (this.isSuccess) {
      return this.successTemplate
    } else {
      return this.leadTemplate || `
        <form id="checkout_form" novalidate="novalidate">
          ${(WebsiteConfigs.showWebshopStripeInvoiceCheckoutHint && !this.withOffer) ? `
            <h5 class="mb-4">
              ${I18n.t('thank_you_for_selecting_items')}
            </h5>` : ''}
          ${this.withOffer ? `
            <h5 class="mb-4">
              ${I18n.t('total_price') + ': ' + this.totalPrice}
            </h5>` : ''}
          <div class="alert alert-danger" id="error_alert" style="display: none;">
            <div class="error-message"></div>
          </div>
          ${this.withOffer ? `
            <div class="form-group">
              <label for="offer">${I18n.t('offer') + ' (' + currency + ')'}</label>
              <input type="number" min="0" name="offer" class="form-control">
            </div>` : ''}
          <div class="form-row">
            <div class="form-group col-6">
              <label for="first_name">${I18n.t('first_name')}</label>
              <input type="text" name="first_name" class="form-control">
            </div>
            <div class="form-group col-6">
              <label for="last_name">${I18n.t('last_name')}</label>
              <input type="text" name="last_name" class="form-control">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-6">
              <label for="phone">${I18n.t('phone')}</label>
              <input type="text" name="phone" class="form-control">
            </div>
            <div class="form-group col-6">
              <label for="email">${I18n.t('email')}</label>
              <input type="text" name="email" class="form-control">
            </div>
          </div>
          ${WebsiteConfigs.createWebshopLead ? '' : `<div class="form-group mt-2">
              <div class="radio-wrapper">
                <div class="custom-control custom-radio">
                  <input type="radio" name="shipping_method" id="shipping" value="shipping" checked="true" class="custom-control-input"></input>
                  <label for="shipping" class="custom-control-label">${I18n.t('shipping')}</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" name="shipping_method" id="pick_up_at_location" value="pick_up_at_location" class="custom-control-input"></input>
                  <label for="pick_up_at_location" class="custom-control-label">${I18n.t('pick_up_at_location')}</label>
                </div>
              </div>
            </div>
            <div class="shipping-address">
              <div class="form-group">
                <label for="address_line_1">${I18n.t('address_line_1')}</label>
                <input type="text" class="form-control" id="address_line_1" name="address_line_1" placeholder="${I18n.t('address_line_1')}" required>
              </div>
              <div class="form-group">
                <label for="address_line_2">${I18n.t('address_line_2')}</label>
                <input type="text" class="form-control" id="address_line_2" name="address_line_2" placeholder="${I18n.t('address_line_2')}">
              </div>
              <div class="form-group">
                <label for="city">${I18n.t('city')}</label>
                <input type="text" class="form-control" id="city" name="city" placeholder="${I18n.t('city')}" required>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="region_state">${I18n.t('region_state')}</label>
                  <input type="text" class="form-control" id="region_state" name="region_state" placeholder="${I18n.t('region_state')}" required>
                </div>
                <div class="form-group col-md-6">
                  <label for="postal_code">${I18n.t('postal_code')}</label>
                  <input type="text" class="form-control" id="postal_code" name="postal_code" placeholder="${I18n.t('postal_code')}">
                </div>
              </div>
              <div class="form-group">
                <label for="country">${I18n.t('country')}</label>
                <select class="form-control" id="country" name="country" required>
                  <option value="">${I18n.t('country')}</option>
                </select>
              </div>
            </div>`}
          <div class="form-group">
            <label for="message">${I18n.t('message')}</label>
            <textarea name="message" class="form-control"></textarea>
          </div>
          ${
  WebsiteConfigs.gdprCompliance ? `<div class="form-check mb-3">
              <label>
                <input type="checkbox" name="receive_newsletters" value="" class="form-check-input">
                ${I18n.t('receive_newsletters')}
              </label>
            </div>` : ''
}
          ${(this.withOffer && WebsiteConfigs.termsOfSalesPath) ? `<div class="form-check mb-3">
            <label>
                <input type="checkbox" name="terms_of_sales_checkbox" value="" class="form-check-input">
                ${I18n.t('by_submitting_an_offer')}
                <a href=${WebsiteConfigs.termsOfSalesPath} target='_blank'>${I18n.t('terms_of_sales')}</a>
                ${I18n.t('should_my_offer_be_accepted')}
              </label>
            </div>` : ''}
          <div class="form-group">
            <button name="button" type="submit" class="btn btn-primary col-12">${I18n.t('submit')}</button>
            ${this.showBack ? `
              <button class="btn btn-secondary col-12 mt-2 checkout-form--back">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                ${I18n.t('back')}
              </button>
            ` : ''}
          </div>
        </form>
      `
    }
  }
}

export default CheckoutForm
